var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"col-2 mx-1 btn-select btn-w-ticketNum",class:{
     'selecting': _vm.isSelecting,
     'functional': _vm.isFunctionBtn
 },on:{"click":function($event){return _vm.btnClick(_vm.num, _vm.isAdult)}}},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.num)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }